'use strict';

import $ from 'jquery';

$(document).ready(function(){
	// add filter wrapper manually
	$('.path-project-evaluations .view-footer > div').not('#block-tabs').wrapAll('<div class="filter-outer"><div class="filter-wrapper"></div></div>');
	$('.path-project-evaluations .filter-wrapper').before('<div class="filter-title"><span>Filter by:</span></div>');
})